import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useToastStore = defineStore('toast', () => {
  const toasts = ref([])
  let idCounter = 0

  function addToast({ message, type = 'info', duration = null, title = '' }) {
    const id = ++idCounter

    // Auto-close durations: A=3s success/info, B=5s warning, C=manual error
    const autoClose = duration !== null ? duration : {
      'success': 3000,
      'info': 3000,
      'warning': 5000,
      'error': 0  // manual close
    }[type] || 3000

    const toast = {
      id,
      message,
      type,
      title,
      autoClose
    }

    toasts.value.push(toast)

    if (autoClose > 0) {
      setTimeout(() => removeToast(id), autoClose)
    }

    return id
  }

  function removeToast(id) {
    const index = toasts.value.findIndex(t => t.id === id)
    if (index > -1) {
      toasts.value.splice(index, 1)
    }
  }

  // Convenience methods
  function success(message, title = '') {
    return addToast({ message, type: 'success', title })
  }

  function error(message, title = 'Ошибка') {
    return addToast({ message, type: 'error', title })
  }

  function warning(message, title = 'Внимание') {
    return addToast({ message, type: 'warning', title })
  }

  function info(message, title = '') {
    return addToast({ message, type: 'info', title })
  }

  return {
    toasts,
    addToast,
    removeToast,
    success,
    error,
    warning,
    info
  }
})